module.exports = __webpack_public_path__ + "0ab54153eeeca0ce03978cc463b257f7.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/icons.woff2
// module id = 250
// module chunks = 4